import { formatCurrency } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { CURRENCY_TYPES, DEFAULT_CURRENCY_FORMAT } from '../currency/currency-types';
import { CurrencyType } from '../currency/currency-types';

@Injectable({
  providedIn: 'root',
})
export class ExchangeMoneyFormatter {
  supportedFormats = [
    {
      currencyCode: CurrencyType.USD,
      currencySymbol: CURRENCY_TYPES.get(CurrencyType.USD)?.symbol ?? '',
      currencyFormat: CURRENCY_TYPES.get(CurrencyType.USD)?.format ?? DEFAULT_CURRENCY_FORMAT,
      exchangeRate: 0,
      requiresMultiMoney: false
    },
    {
      currencyCode: CurrencyType.COP,
      currencySymbol: CURRENCY_TYPES.get(CurrencyType.COP)?.symbol ?? '',
      currencyFormat: CURRENCY_TYPES.get(CurrencyType.COP)?.format ?? DEFAULT_CURRENCY_FORMAT,
      exchangeRate: 0,
      requiresMultiMoney: true
    },
  ];

  constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

  getFormat(currencyCode: string): ExchangeMoney {
    return this.supportedFormats.find((f) => f.currencyCode === currencyCode);
  }

  refreshExchangeRates(exchangeRates: ExchangeRates[]): void {
    exchangeRates.forEach((rate) => {
      const format = this.supportedFormats.find((f) => f.currencyCode === rate.currencyCode);
      if (format) {
        format.exchangeRate = rate.exchangeRate;
      }
    });
  }

  /**
   * Formatea un valor en la moneda indicada usando las tasas de refreshExchangeRates y el
   * currencyFormat definido en supportedFormats para esa moneda.
   */
  format(value: number, currencyCode: string): string {
    const format = this.supportedFormats.find((f) => f.currencyCode === currencyCode);
    if (!format) {
      return value.toString();
    }

    if (format.exchangeRate === 0) {
      return '';
    }

    const finalValue = value / format.exchangeRate;
    return formatCurrency(
      finalValue,
      this.locale,
      format.currencySymbol,
      format.currencyCode,
      format.currencyFormat
    );
  }
}

export interface ExchangeMoney {
  currencyCode: string;
  currencySymbol: string;
  currencyFormat: string;
  exchangeRate: number;
  requiresMultiMoney: boolean;
}

export interface ExchangeRates {
  currencyCode: string;
  exchangeRate: number;
}
